import { classNames } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import { A, pipe } from "@mobily/ts-belt"
import findMany from "cc-frontend/helpers/find-many"
import { isCachedMembershipActive } from "cc-frontend/utils/group"
import _ from "lodash"

@classNames("user-home__body__schools__school")
export default class UserHomeSchool extends Component {
  @service("ember-store")
  store

  @computed("user.attributes.cachedMemberships.length", "group.attributes.memberships.length")
  get userTeamIds() {
    const userGroupIds = pipe(
      get(this, "user.attributes.cachedMemberships"),
      A.filter(isCachedMembershipActive),
      A.map((membership) => membership.groupId)
    )
    let teams = _.filter(
      get(this, "group.attributes.memberships"),
      (membership) => membership.type === "group-membership-group"
    )
    return _.chain(teams)
      .filter((team) => _.includes(userGroupIds, team.attributes.groupId))
      .map((team) => team.attributes.groupId)
      .value()
  }

  @findMany("userTeamIds", "group")
  teams
}
